import {Module} from "vuex";
import {OrderFinancing, OrderFinancingState} from "@/types";
import {getOrderFinancing, getTauxPrimable} from "@/store/services/order/financing/orderFinancingService";
import {syncCrediparContract} from "@/store/services/order/eflorouterApi";
import store from "@/store";


const orderFinancingModule: Module<OrderFinancingState, any> = {
    namespaced: true,
    state: {
         financing: {
             type: {
                 label: '',
                 value: ''
             },
             label: '',
             offerReference: '',
             scale: '',
             financingProductPack: {},
             financingOrganization:{},
             associatedParty: {
                 orderParty: {
                     party: {},
                     role: {},
                     third: {}
                }
             },
             financedAmountWTax: {
                 amount: 0,
                 currency: 'EUR'
             },
             financedAmountWoTax: {
                 amount: 0,
                 currency: 'EUR'
             },
             deposit: {
                 amount: 0,
                 currency: 'EUR'
             },
             contribution: {
                 amount: 0,
                 currency: 'EUR'
             },
             firstRent: {
                 amount: 0,
                 currency: 'EUR'
             },
            eligibleAmountWoTax: {
                 amount: 0,
                 currency: 'EUR'
             },
             eligibleAmountWTax: {
                 amount: 0,
                 currency: 'EUR'
             },
             numberOfInsurances: undefined,
             financedDuration: undefined,
             typeRate: undefined,
             numberOfServices: undefined,
             contractMileage: undefined,
             calculatedErAmount: {
                 amount: 0,
                 currency: 'EUR'
             },
             erAmountRetained: {
                 amount: 0,
                 currency: 'EUR'
             },
             rentAndServicesTc: {
                 amount: 0,
                 currency: 'EUR'
             },
             rentTc: {
                 amount: 0,
                 currency: 'EUR'
             }
         },
    },
    getters:{
        getOrderFinancingInit(): OrderFinancing {
            return {
                type: {
                    label: '',
                    value: ''
                },
                label: '',
                offerReference: '',
                scale: '',
                financingProductPack: {},
                financingOrganization:{},
                associatedParty: {
                    orderParty: {
                        party: {},
                        role: {},
                        third: {}
                    }
                },
                financedAmountWTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                financedAmountWoTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                deposit: {
                 amount: 0,
                 currency: 'EUR'
                },
                contribution: {
                    amount: 0,
                    currency: 'EUR'
                },
                firstRent: {
                    amount: 0,
                    currency: 'EUR'
                },
                eligibleAmountWoTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                eligibleAmountWTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                numberOfInsurances: undefined,
                financedDuration: undefined,
                typeRate: undefined,
                numberOfServices: undefined,
                contractMileage: undefined,
                calculatedErAmount: {
                    amount: 0,
                    currency: 'EUR'
                },
                erAmountRetained: {
                    amount: 0,
                    currency: 'EUR'
                },
                rentAndServicesTc: {
                    amount: 0,
                    currency: 'EUR'
                },
                rentTc: {
                    amount: 0,
                    currency: 'EUR'
                }
            }
        },
        getOrderFinancing(state) {
            return state.financing;
        },
    },
    actions: {
        async getFinancing({commit, getters}, payload) {
            const {resourceUid, callback} = payload
            await getOrderFinancing(resourceUid).then((response: any) => {
                if (response) {
                    commit('setFinancing', response)
                    callback(response);
                } else {
                    commit('setFinancing', getters.getOrderFinancingInit)
                }
            })
        },
        setOrderAssociatedParty({ commit }, payload) {
            commit('setOrderAssociatedParty', payload)
        },
        setFinancingLabel({ commit }, payload) {
            commit('setFinancingLabel', payload)
        },
        cleanState({ commit }) {
            commit('setInitial')

        },
        resetFinancing({ commit, getters, state }) {
            const currentType = state.financing?.type;
            const isCpt = currentType?.value?.trim().toUpperCase() === 'CPT';

            commit('setFinancing', {
                ...getters.getOrderFinancingInit,
                type: isCpt ? currentType : {
                    label: 'CPT',
                    value: 'CPT'
                },
                label: 'CPT',
            });

            const currentParties = store.state.orderPartyModule.orderParties || [];
            const withoutFinancier = currentParties.filter((p: any) => p.role_code !== 'FINANCIER');
            if (withoutFinancier.length !== currentParties.length) {
                store.dispatch('orderPartyModule/setOrderParties', { orderParties: withoutFinancier });
            }
        },
    getTauxPrimable({ commit }, payload) {
      const { filter, callback } = payload;
      getTauxPrimable(filter)
        .then((res:any) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    async syncCredipar({ dispatch, state, commit }, payload) {
      const { contractRef, affaireId, orderId, onStart, onDone, onError } = payload;
      try {
        if (onStart) onStart();
        await syncCrediparContract({ contractRef, affaireId, orderId });
        const prev = (state as any).financing || {};
        const preservedParty = prev.associatedParty;
        const preservedOrg = prev.financingOrganization;
        const financingResourceUid = prev.resourceUid;
        if (financingResourceUid) {
          await dispatch("getFinancing", { resourceUid: financingResourceUid, callback: () => undefined });
          const refreshed = { ...(state as any).financing };
          if (preservedParty) refreshed.associatedParty = preservedParty;
          if (preservedOrg) refreshed.financingOrganization = preservedOrg;
          commit("setFinancing", refreshed);
        }
        if (onDone) onDone();
      } catch (e) {
        console.error("CREDIPAR sync failed", e);
        if (onError) onError(e);
      }
    },
    },
    mutations: {
        setInitial(state) {
            state.financing = {}
        },
        setFinancing(state, payload) {
            state.financing = payload
        },
        setOrderAssociatedParty(state, payload){
            const {party, role, objectType} = payload
            if(state.financing && state.financing.associatedParty
                    && state.financing.associatedParty.orderParty
                    && state.financing.associatedParty.orderParty.party
                    && state.financing.associatedParty.orderParty.role) {
                        console.log(state.financing)
                state.financing.associatedParty.orderParty.party.resourceUid = party
                state.financing.associatedParty.orderParty.party.objectType = objectType
                state.financing.associatedParty.orderParty.role.resourceUid = role
            }
            else if(state.financing && !state.financing.associatedParty) {
                const associatedParty = {
                    orderParty: {
                        party: {},
                        role: {},
                        third: {}
                    }
                }
                state.financing.associatedParty = associatedParty
            }
        },
        setFinancingLabel(state, payload){
            if(state.financing){
                state.financing.label = payload.value
            }
        },

    }
}

export default orderFinancingModule;
